module.exports = __webpack_public_path__ + "img/zipcode.7fbbec3f.png";